module.exports = __webpack_public_path__ + "img/avti_6.ef0c0399.png";